// All tooltips called by getCustomizedHeaders
const tableHeaderOptionsGenericTooltips = {
  "table-treasury": "Latest value of the project’s funds held on-chain",
  "table-treasury_24h_change": "Treasury change in the past 24 hours (%)",
  "table-treasury_7d_change": "Treasury change in the past 7 days (%)",
  "table-treasury_30d_change": "Treasury change in the past 30 days (%)",
  "table-treasury_90d_change": "Treasury change in the past 90 days (%)",
  "table-treasury_180d_change": "Treasury change in the past 180 days (%)",
  "table-treasury_365d_change": "Treasury change in the past 365 days (%)",

  "table-active_developers":
    "Latest number of distinct GitHub users that made 1+ commits to the project's public GitHub repositories during the past 30 days.",
  "table-active_developers_7d_change":
    "Change of distinct GitHub users that made 1+ commits to the project's public GitHub repositories during the past 7 days (%)",
  "table-active_developers_30d_change":
    "Change of distinct GitHub users that made 1+ commits to the project's public GitHub repositories during the past 30 days (%)",
  "table-active_developers_90d_change":
    "Change of distinct GitHub users that made 1+ commits to the project's public GitHub repositories during the past 90 days (%)",
  "table-active_developers_180d_change":
    "Change of distinct GitHub users that made 1+ commits to the project's public GitHub repositories during the past 180 days (%)",
  "table-active_developers_365d_change":
    "Change of distinct GitHub users that made 1+ commits to the project's public GitHub repositories during the past 365 days (%)",

  "table-code_commits":
    "Number of commits to the project’s public GitHub repositories in the past 24 hours.",
  "table-code_commits_7d":
    "Number of commits to the project’s public GitHub repositories in the past 7 days.",
  "table-code_commits_30d":
    "Number of commits to the project’s public GitHub repositories in the past 30 days.",
  "table-code_commits_7d_trend_change":
    "Number of commits trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-code_commits_30d_trend_change":
    "Number of commits trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-code_commits_180d_trend_change":
    "Number of commits trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-code_commits_365d_trend_change":
    "Number of commits trend in the past 365 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-code_commits_7d_change":
    "Change in number of commits to the project’s public GitHub repositories during the past 7 days (%)",
  "table-code_commits_30d_change":
    "Change in umber of commits to the project’s public GitHub repositories during the past 30 days (%)",
  "table-code_commits_90d_change":
    "Change in number of commits to the project’s public GitHub repositories during the past 90 days (%)",
  "table-code_commits_180d_change":
    "Change in number of commits to the project’s public GitHub repositories during the past 180 days (%)",
  "table-code_commits_365d_change":
    "Change in number of commits to the project’s public GitHub repositories during the past 365 days (%)",

  "table-active_users":
    "Latest number of distinct addresses interacting with business relevant contracts",
  "table-active_users_7d_change":
    "Change of distinct addresses interacting with business relevant contracts in the past 7 days (%)",
  "table-active_users_30d_change":
    "Change of distinct addresses interacting with business relevant contracts in the past 30 days (%)",
  "table-active_users_90d_change":
    "Change of distinct addresses interacting with business relevant contracts in the past 90 days (%)",
  "table-active_users_180d_change":
    "Change of distinct addresses interacting with business relevant contracts in the past 180 days (%)",
  "table-active_users_365d_change":
    "Change of distinct addresses interacting with business relevant contracts in the past 365 days (%)",
  "table-market_cap_24h_change": "Market cap change in the past 24 hours (%)",
  "table-market_cap_7d_change": "Market cap change in the past 7 days (%)",
  "table-market_cap_30d_change": "Market cap change in the past 30 days (%)",
  "table-market_cap_90d_change": "Market cap change in the past 90 days (%)",
  "table-market_cap_180d_change": "Market cap change in the past 180 days (%)",
  "table-market_cap_24h_trend_change":
    "Market cap trend in the past 24 hours (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_7d_trend_change":
    "Market cap trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_30d_trend_change":
    "Market cap trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_90d_trend_change":
    "Market cap trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_180d_trend_change":
    "Market cap trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_fully_diluted_24h_trend_change":
    "Market cap fully diluted trend in the past 24 hours (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_fully_diluted_7d_trend_change":
    "Market cap fully diluted trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_fully_diluted_30d_trend_change":
    "Market cap fully diluted trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_fully_diluted_90d_trend_change":
    "Market cap fully diluted trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-market_cap_fully_diluted_180d_trend_change":
    "Market cap fully diluted trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-price_24h_trend_change":
    "Price trend in the past 24 hours (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-price_7d_trend_change":
    "Price trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-price_30d_trend_change":
    "Price trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-price_90d_trend_change":
    "Price trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-price_180d_trend_change":
    "Price trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-ps_24h_trend_change":
    "P/F trend in the past 24 hours (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-ps_7d_trend_change":
    "P/F trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-ps_30d_trend_change":
    "P/F trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-ps_90d_trend_change":
    "P/F trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-ps_180d_trend_change":
    "P/F trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-pe_24h_trend_change":
    "P/S trend in the past 24 hours (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-pe_7d_trend_change":
    "P/S trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-pe_30d_trend_change":
    "P/S trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-pe_90d_trend_change":
    "P/S trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-pe_180d_trend_change":
    "P/S trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-tvl_24h_trend_change":
    "TVL trend in the past 24 hours (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-tvl_7d_trend_change":
    "TVL trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-tvl_30d_trend_change":
    "TVL trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-tvl_90d_trend_change":
    "TVL trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-tvl_180d_trend_change":
    "TVL trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_total_24h_trend_change":
    "Fee trend in the past 24 hours (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_total_7d_trend_change":
    "Fee trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_total_30d_trend_change":
    "Fee trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_total_90d_trend_change":
    "Fee trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_total_180d_trend_change":
    "Fee trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_total_365d_trend_change":
    "Fee trend in the past 365 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_protocol_24h_trend_change":
    "Revenue trend in the past 24 hours (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_protocol_7d_trend_change":
    "Revenue trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_protocol_30d_trend_change":
    "Revenue trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_protocol_90d_trend_change":
    "Revenue trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_protocol_180d_trend_change":
    "Revenue trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_protocol_365d_trend_change":
    "Revenue trend in the past 365 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-project": "Name of the project.",
  "table-price": "Price of the token.",
  "table-price_24h": "Price change in the past 24h.",
  "table-price_7d": "Price change in the past 7 days.",
  "table-market_cap":
    "Latest market cap / valuation based on the max. supply of tokens.",
  "table-market_cap_circulating":
    "Latest market cap / valuation based on circulating supply of tokens.",
  "table-market_cap_circulating_24h_change":
    "Fully circulating market cap / valuation based change in the past 24 hours.",
  "table-market_cap_circulating_7d_change":
    "Fully circulating market cap / valuation based change in the past 7 days.",
  "table-market_cap_circulating_30d_change":
    "Fully circulating market cap / valuation based change in the past 30 days.",
  "table-market_cap_circulating_180d_change":
    "Fully circulating market cap / valuation based change in the past 180 days.",
  "table-market_cap_circulating_365d_change":
    "Fully circulating market cap / valuation based change in the past 365 days.",
  "table-market_cap_fully_diluted":
    "Latest market cap / valuation based on the max. supply of tokens.",
  "table-market_cap_fully_diluted_24h_change":
    "Fully diluted market cap / valuation based change in the past 24 hours.",
  "table-market_cap_fully_diluted_7d_change":
    "Fully diluted market cap / valuation based change in the past 7 days.",
  "table-market_cap_fully_diluted_30d_change":
    "Fully diluted market cap / valuation based change in the past 30 days.",
  "table-market_cap_fully_diluted_180d_change":
    "Fully diluted market cap / valuation based change in the past 180 days.",
  "table-market_cap_fully_diluted_365d_change":
    "Fully diluted market cap / valuation based change in the past 365 days.",
  "table-token_trading_volume":
    "Latest trading volume for the project's own token.",
  "table-token_trading_volume_7d":
    "Trading volume of token in the past 7 days.",
  "table-token_trading_volume_30d":
    "Trading volume of token in the past 30 days.",
  "table-token_trading_volume_7d_trend_change":
    "Trading volume of token in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_trading_volume_30d_trend_change":
    "Trading volume of token in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_trading_volume_90d_trend_change":
    "Trading volume of token in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_trading_volume_180d_trend_change":
    "Trading volume of token in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_trading_volume_365d_trend_change":
    "Trading volume of token in the past 365 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-tokenholders": "Number of tokenholders",
  "table-tokenholders_24h_change":
    "Number of tokenholders based change in the past 24 hours.",
  "table-tokenholders_7d_change":
    "Number of tokenholders based change in the past 7 days.",
  "table-tokenholders_30d_change":
    "Number of tokenholders based change in the past 30 days.",
  "table-tokenholders_180d_change":
    "Number of tokenholders based change in the past 180 days.",
  "table-tokenholders_365d_change":
    "Number of tokenholders based change in the past 365 days.",
  "table-tvl":
    "Latest total value locked. Shows how much money is currently deposited into a project’s smart contracts.",
  "table-tvl_24h_change": "TVL change in the past 24 hours.",
  "table-tvl_7d":
    "TVL calculated based on past 7 days average of listed projects.",
  "table-tvl_7d_change": "TVL change in the past 7 days.",
  "table-tvl_30d_change": "TVL change in the past 30 days.",
  "table-tvl_90d_change": "TVL change in the past 90 days.",
  "table-tvl_180d_change": "TVL change in the past 180 days.",
  "table-tvl_365d_change": "TVL change in the past 365 days.",
  "table-ps_fully_diluted":
    "Latest price to fees (P/F) ratio. Calculated by dividing the fully diluted market cap with the annualized fees. Shows how a project is valued in relation to its fees.",
  "table-ps_circulating":
    "Latest price to fees (P/F) ratio. Calculated by dividing the circulating market cap with the annualized fees. Shows how a project is valued in relation to its fees.",
  "table-pe_fully_diluted":
    "Latest price to sales (P/S) ratio. Calculated by dividing the fully diluted market cap with the annualized revenue. Shows how a project is valued in relation to its revenue.",
  "table-pe_circulating":
    "Latest price to sales (P/S) ratio. Calculated by dividing the circulating market cap with the annualized revenue. Shows how a project is valued in relation to its revenue.",
  "table-pe_circulating_24h_change": "P/S change in the past 24 hours.",
  "table-pe_circulating_7d_change": "P/S change in the past 7 days.",
  "table-pe_circulating_30d_change": "P/S change in the past 30 days.",
  "table-pe_circulating_180d_change": "P/S change in the past 180 days.",
  "table-pe_circulating_365d_change": "P/S change in the past 365 days.",
  "table-pe_fully_diluted_24h_change": "P/S change in the past 24 hours.",
  "table-pe_fully_diluted_7d_change": "P/S change in the past 7 days.",
  "table-pe_fully_diluted_30d_change": "P/S change in the past 30 days.",
  "table-pe_fully_diluted_180d_change": "P/S change in the past 180 days.",
  "table-pe_fully_diluted_365d_change": "P/S change in the past 365 days.",
  "table-ps_circulating_24h_change": "P/F change in the past 24 hours.",
  "table-ps_circulating_7d_change": "P/F change in the past 7 days.",
  "table-ps_circulating_30d_change": "P/F change in the past 30 days.",
  "table-ps_circulating_180d_change": "P/F change in the past 180 days.",
  "table-ps_circulating_365d_change": "P/F change in the past 365 days.",
  "table-ps_fully_diluted_24h_change": "P/F change in the past 24 hours.",
  "table-ps_fully_diluted_7d_change": "P/F change in the past 7 days.",
  "table-ps_fully_diluted_30d_change": "P/F change in the past 30 days.",
  "table-ps_fully_diluted_180d_change": "P/F change in the past 180 days.",
  "table-ps_fully_diluted_365d_change": "P/F change in the past 365 days.",
  "table-price_24h_change": "Price change in the past 24h.",
  "table-price_7d_change": "Price change in the past 7 days.",
  "table-price_30d_change": "Price change in the past 30 days.",
  "table-price_90d_change": "Price change in the past 90 days.",
  "table-price_180d_change": "Price change in the past 180 days.",
  "table-price_ath": "The highest value that the token has traded.",
  "table-price_atl": "The lowest value that the token has traded.",
  "table-revenue_total_annualized":
    "Fees on an annualized basis. Calculated based on past 30D average.",
  "table-revenue_total_90d_change": "Fee change in the past 90 days.",
  "table-revenue_protocol":
    "Fees generated for the tokenholders in the past 24 hours.",
  "table-revenue_protocol_1d":
    "Fees generated for the tokenholders in the past 24 hours.",
  "table-revenue_protocol_7d":
    "Fees generated for the tokenholders in the past 7 days.",
  "table-revenue_protocol_30d":
    "Fees generated for the tokenholders in the past 30 days.",
  "table-revenue_protocol_90d":
    "Fees generated for the tokenholders in the past 90 days.",
  "table-revenue_protocol_annualized":
    "Fees on an annualized basis. Calculated based on past 30D average.",
  "table-revenue_protocol_180d":
    "Fees generated for the tokenholders in the past 180 days.",
  "table-revenue_protocol_365d":
    "Fees generated for the tokenholders in the past 365 days.",
  "table-revenue_protocol_all":
    "Fees generated for the tokenholders since launch.",
  "table-revenue_supply_side_24h":
    "Fees generated for the supply-side in the past 24 hours.",
  "table-revenue_supply_side_1d":
    "Fees generated for the supply-side in the past 24 hours.",
  "table-revenue_supply_side_7d":
    "Fees generated for the supply-side in the past 7 days.",
  "table-revenue_supply_side_30d":
    "Fees generated for the supply-side in the past 30 days.",
  "table-revenue_supply_side_90d":
    "Fees generated for the supply-side in the past 90 days.",
  "table-revenue_supply_side_180d":
    "Fees generated for the supply-side in the past 180 days.",
  "table-revenue_supply_side_365d":
    "Fees generated for the supply-side in the past 365 days.",
  "table-revenue_supply_side_all":
    "Fees generated for the supply-side since launch.",
  "table-token_incentives":
    "USD value of the tokens that have been distributed to incentivise users in the past 24 hours.",
  "table-token_incentives_1d":
    "USD value of the tokens that have been distributed to incentivise users in the past 24 hours.",
  "table-token_incentives_7d":
    "USD value of the tokens that have been distributed to incentivise users in the past 7 days.",
  "table-token_incentives_30d":
    "USD value of the tokens that have been distributed to incentivise users in the past 30 days.",
  "table-token_incentives_90d":
    "USD value of the tokens that have been distributed to incentivise users in the past 90 days.",
  "table-token_incentives_180d":
    "USD value of the tokens that have been distributed to incentivise users in the past 180 days.",
  "table-token_incentives_365d":
    "USD value of the tokens that have been distributed to incentivise users in the past 365 days.",
  "table-token_incentives_7d_trend_change":
    "Token incentives trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_incentives_30d_trend_change":
    "Token incentives trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_incentives_90d_trend_change":
    "Token incentives trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_incentives_180d_trend_change":
    "Token incentives trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_incentives_365d_trend_change":
    "Token incentives trend in the past 365 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-token_incentives_all":
    "USD value of the tokens that have been distributed to incentivise users since launch.",
  "table-earnings": "Revenue minus token incentives in the past 24 hours",
  "table-earnings_7d": "Revenue minus token incentives in the past 7 days",
  "table-earnings_30d": "Revenue minus token incentives in the past 30 days",
  "table-earnings_7d_trend_change":
    "Revenue minus token incentives trend in the past 7 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-earnings_30d_trend_change":
    "Revenue minus token incentives trend in the past 30 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-earnings_90d_trend_change":
    "Revenue minus token incentives trend in the past 90 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-earnings_180d_trend_change":
    "Revenue minus token incentives trend in the past 180 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-earnings_365d_trend_change":
    "Revenue minus token incentives trend in the past 365 days (%). Trend is calculated by comparing the given time interval to the previous time interval.",
  "table-revenue_protocol_24h_change": "Revenue change in the past 24 hours.",
  "table-revenue_protocol_7d_change": "Revenue change in the past 7 days.",
  "table-revenue_protocol_90d_change": "Revenue change in the past 90 days.",
  "table-tvl_24h":
    "TVL calculated based on past 24h average of listed projects.",
  "table-tvl_avg_24h":
    "TVL calculated based on past 24h average of listed projects.",
  "table-tvl_90d":
    "TVL calculated based on past 90d average of listed projects.",
  "table-tvl_avg_90d":
    "TVL calculated based on past 90d average of listed projects.",
  "table-tvl_180d":
    "TVL calculated based on past 180d average of listed projects.",
  "table-tvl_avg_180d":
    "TVL calculated based on past 180d average of listed projects.",
  "table-ps_fully_diluted_24h":
    "P/F ratio calculated based on past 24h average.",
  "table-ps_fully_diluted_7d": "P/F ratio calculated based on past 7d average.",
  "table-ps_fully_diluted_30d":
    "P/F ratio calculated based on past 30d average.",
  "table-ps_fully_diluted_90d":
    "P/F ratio calculated based on past 90d average.",
  "table-ps_fully_diluted_180d":
    "P/F ratio calculated based on past 180d average.",
  "table-ps_fully_diluted_90d_change": "P/F change in the past 90 days.",
  "table-twitter_followers": "Number of twitter followers.",

  "table-revenue_total": "Fees paid in the past 24 hours.",
  "table-revenue_total_1d": "Daily fees. Fees paid in the past 24 hours.",
  "table-revenue_total_24h": "Daily fees. Fees paid in the past 24 hours.",
  "table-revenue_total_7d": "Weekly fees. Fees paid in the past 7 days.",
  "table-revenue_total_30d": "Monthly fees. Fees paid in the past 30 days.",
  "table-revenue_total_90d": "Quarterly fees. Fees paid in the past 90 days.",
  "table-revenue_total_180d":
    "Semi-annual fees. Fees paid in the past 180 days.",
  "table-revenue_total_365d":
    "Annual revenue. Fees paid in the past3 365 days.",
  "table-revenue_total_all": "Fees paid since launch.",
  "table-revenue_total_24h_change": "Fee change in the past 24 hours.",
  "table-revenue_total_7d_change": "Fee change in the past 7 days.",
  "table-revenue_total_30d_change": "Fee change in the past 30 days.",
  "table-revenue_total_180d_change": "Fee change in the past 180 days.",

  "table-revenue-protocol_24h":
    "Daily revenue. Fees paid to tokenholders in the past 24 hours.",
  "table-revenue-protocol_7d":
    "Weekly revenue. Fees paid to tokenholders in the past 7 days.",
  "table-revenue-protocol_30d":
    "Monthly fees. Fees paid to tokenholders in the past 30 days.",
  "table-revenue-protocol_180d":
    "Semi-annual revenue. Fees paid to tokenholders in the past 180 days.",
  "table-revenue-protocol_24h_change": "Revenue change in the past 24 hours.",
  "table-revenue-protocol_7d_change": "Revenue change in the past 7 days.",
  "table-revenue_protocol_30d_change": "Revenue change in the past 30 days.",
  "table-revenue_protocol_180d_change": "Revenue change in the past 180 days.",
  "table-_change": "TVL change in the past 7 days.",
  "table-tvl_30d":
    "TVL calculated based on past 30D average of listed projects.",
  "table-pe_24h_change": "P/S ratio change in the past 24 hours.",
  "table-pe_7d_change": "P/S ratio change in the past 7 days.",
  "table-pe_30d_change": "P/S ratio change in the past 30 days.",
  "table-pe_90d_change": "P/S ratio change in the past 90 days.",
  "table-pe_180d_change": "P/S ratio change in the past 180 days.",
}

const trendingContracsTooltips = {
  "trending-contracts-label": "Description or name of the smart contract.",
  "trending-contracts-address":
    "Smart contract address with link to block explorer.",
  "trending-contracts-gas":
    "Amount of gas consumed (in USD) by the smart contract.",
  "trending-contracts-transactions":
    "Amount of transactions sent to the smart contract.",
  "trending-contracts-users":
    "Number of distinct addresses that sent transactions to the smart contract.",
  "trending-contracts-unlabeled":
    "The smart contract is not labeled or identified yet.",
  "trending-contracts-label-by-project": "Project name",
  "trending-contracts-gas-by-project":
    "Amount of gas consumed (in USD) by the trending smart contracts of the project.",
  "trending-contracts-transactions-by-project":
    "Amount of transactions sent to the trending smart contracts of the project.",
  "trending-contracts-users-by-project":
    "Number of distinct addresses that sent transactions to the trending smart contracts of the project.",
}

export const tooltipTexts: {
  [key: string]: string | { [key: string]: string }
} = {
  ...tableHeaderOptionsGenericTooltips,
  ...trendingContracsTooltips,
  "custom-chart-no-metric": "Please select a metric first.",
  "momentum-revenue":
    "Revenue trend in the past 7 days. Trend is calculated by comparing the given time interval to the previous time interval.",
  "momentum-fees":
    "Fee trend in the past 7 days. Trend is calculated by comparing the given time interval to the previous time interval.",
  "momentum-tvl":
    "Latest total value locked (TVL) trend in the past 7 days. Trend is calculated by comparing the given time interval to the previous time interval.",
  "momentum-ps":
    "Latest price to sales (P/S) trend in the past 7 days. Trend is calculated by comparing the given time interval to the previous time interval.",
  "momentum-pf":
    "Latest price to fees (P/F) trend in the past 7 days. Trend is calculated by comparing the given time interval to the previous time interval.",
  "home-chart-0": "Revenue",
  "home-chart-1": "Historical fees",
  "home-chart-2": "Fees",
  "home-chart-3": "Historical revenue",
  "home-chart-4": "Price to fees (P/F) ratio based on fees",
  "home-chart-5": "Price to sales (P/S) ratio based on revenue",
  "home-chart-6": "Total value locked (TVL)",
  "home-chart-7": "Historical total value locked (TVL)",
  "project-ps":
    "Price to sales (P/S) ratio. Calculated by dividing the fully diluted market cap with the annualized revenue. Shows how a project is valued in relation to its revenue.",
  "chart-key-metrics":
    "Toggle between different key metrics and choose a time window.",
  "chart-revenue-share":
    "How are the fees divided between the supply-side participants and the tokenholders?",
  "chart-composition":
    "Which assets contribute most to the chosen metric. For example, which pool generates most trading fees.",
  "chart-composition-by-chain":
    "Which chains contribute the most to the chosen metric. For example, which chain generates the most fees.",
  "chart-competitive":
    "Choose a metric and compare the performance between two or more projects.",
  "chart-data-table": "Access the data in table format.",
  "chart-1d": "Show past day.",
  "chart-7d": "Show past week.",
  "chart-30d": "Show past month.",
  "chart-90d": "Show past quarter.",
  "chart-180d": "Show past six months.",
  "chart-ytd": "Show year to date",
  "chart-365d": "Show past year.",
  "chart-max": "Show since launch.",
  "chart-latest": "Show latest.",
  "chart-expand": "Expand the chart for a screenshot.",
  "chart-embed": "Embed this chart on your website.",
  "chart-more-info": "Show info about methodology & sources",
  "chart-copy-link": "Copy a shareable link to the chart.",
  "table-download-allowed": "Download table in CSV.",
  "chart-download-allowed": "Download chart in CSV.",
  "scr-download-allowed": "Download data in CSV.",
  "chart-total-revenue": "Fees paid by users.",
  "chart-historical-total-revenue": "Fees paid by users.",
  "chart-protocol-revenue": "Fees generated for the tokenholders.",
  "chart-historical-protocol-revenue": "Fees generated for the tokenholders.",
  "chart-ps":
    "Calculated by dividing the fully diluted market cap with the annualized fees. Shows how a project is valued in relation to its fees.",
  "chart-metric-competitive": "Compare metrics with 2 or more projects.",
  "chart-tvl": "Total value of funds locked in the project’s smart contracts.",
  "chart-market-metrics":
    "Toggle between different market metrics and choose the time window.",
  "chart-historical-market_cap":
    "Market cap change over time, expressed as a percentage.",
  "chart-historical-tvl":
    "Total value of funds locked in the project’s smart contracts.",
  "chart-historical-ps":
    "P/F ratio change over time, expressed as a percentage.",
  "chart-historical-pe":
    "P/S ratio change over time, expressed as a percentage.",
  "chart-historical-price":
    "Price change of a token over time, expressed as a percentage.",
  "chart-historical-tokenholders":
    "Tokenholders change of a token over time, expressed as a percentage.",
  "chart-historical-active_users":
    "Change in active users over time, expressed as a percentage.",
  "chart-historical-revenue":
    "Trend is calculated by comparing the given time interval to the previous time interval. E.g. 30d trend is equal to the percentage change between cumulative revenue over the past 30 days and the 30 days before that.",
  "chart-historical-treasury":
    "Trend is calculated by comparing the given time interval to the previous time interval. E.g. 30d trend is equal to the percentage change between cumulative treasury over the past 30 days and the 30 days before that.",
  "chart-historical-revenue_protocol":
    "Trend is calculated by comparing the given time interval to the previous time interval. E.g. 30d trend is equal to the percentage change between cumulative revenue over the past 30 days and the 30 days before that.",
  "favorites-add-project": "Add a new project to favorites.",
  "project-ath":
    "All time high. The highest price that the token has traded at.",
  "project-atl": "All time low. The lowest price that the token has traded at.",
  "project-markets": "Exchanges where the token can be traded.",
  "project-marketcap":
    "Market cap / valuation based on circulating supply of tokens.",
  "project-fully-diluted":
    "Market cap / valuation based on the max. supply of tokens.",
  "project-trading-vol-30d": "Trading volume in the past 30 days.",
  "project-annualized-transaction-vol":
    "Transaction volume on an annualized basis. Calculated based on past 30D average.",
  "project-revenue-7d": "Fees paid in the past 7 days.",
  "project-revenue-30d": "Fees paid in the past 30 days.",
  "project-revenue-annualized":
    "Fees paid on an annualized basis. Calculated based on past 30D average.",
  "project-tvl":
    "Total value locked. Shows how much money is currently deposited into a project’s smart contracts.",
  "project-pf":
    "Price to fees (P/F) ratio. Calculated by dividing the fully diluted or circulating market cap with the annualized fees. Shows how a project is valued in relation to its fees.",
  "project-exchanges":
    "On what exchanges is the token listed/where can the token be traded?",
  "keymetrics-treasury": "Value of the project’s funds held on-chain",
  "keymetrics-market-cap":
    "Choose between fully diluted or circulating market capitalization",
  "keymetrics-tvl": "Value of funds locked in the project's smart contracts",
  "keymetrics-pf-fully-diluted":
    "Fully diluted market cap divided by annualized fees",
  "keymetrics-pf-circulating":
    "Fully circulating market cap divided by annualized fees",
  "keymetrics-ps-fully-diluted":
    "Fully diluted market cap divided by annualized revenue",
  "keymetrics-ps-circulating":
    "Fully circulating market cap divided by annualized revenue",
  "keymetrics-token-incentives": "Value of governance tokens distributed",
  "keymetrics-volume": "Trading volume for the project's own token",
  "keymetrics-price": "Price of the token",
  "keymetrics-revenue": "Fees paid",
  "keymetrics-revenue-protocol": "Fees generated for the tokenholders",
  "keymetrics-revenue-supply-side":
    "Fees generated for the supply-side participants",
  "keymetrics-market-cap-fully-diluted":
    "Market cap / valuation based on the max. supply of tokens",
  "keymetrics-market-cap-circulating":
    "Market cap / valuation based on the circulating supply of tokens",
  "revenue-supply-side": "Shows how much of fees goes to the supply-side.",
  "revenue-protocol": "Shows how much of fees goes to the tokenholders.",
  "composition-tvl": "TVL per asset",
  "composition-revenue": "Fees per asset",
  "composition-treasury": "Treasury value per asset",
  "composition-active-users": "Active users per usage type",
  "competitive-metric": "Choose a metric you want to compare projects on.",
  "competitive-add-project": "Add a new project to the comparison.",
  "custom-chart-type": "Choose chart type.",
  "custom-chart-stacked":
    "Choose whether you want the results to be stacked or unstacked.",
  "markets-revenue": "Fees generated by listed protocols.",
  "markets-tvl": "Value of funds locked in the project's smart contracts.",
  "markets-market-cap-fully-diluted":
    "Market cap / valuation based on max.supply of tokens.",
  "markets-market-cap-circulating":
    "Market cap / valuation based on the circulating supply of tokens",
  "markets-pf-fully-diluted":
    "Fully diluted market cap divided by annualized fees",
  "markets-pf-circulating":
    "Fully circulating market cap divided by annualized fees",
  "markets-ps-fully-diluted":
    "Fully diluted market cap divided by annualized revenue",
  "markets-ps-circulating":
    "Fully circulating market cap divided by annualized revenue",
  "markets-total-revenue": "",
  "markets-total-ps": "",
  "markets-median-revenue": "",
  "markets-dominance": "The leading dapp’s share of total exchange revenue.",
  "markets-title": "",
  "ps-dapps": "P/F ratio across popular decentralized applications.",
  "ps-blockchains": "P/F ratio across popular blockchains.",
  "tvl-dapps": "Total value locked across popular decentralized applications.",
  "protocol-revenue-defi": "Revenue across popular decentralized applications.",
  "protocol-revenue-blockchain": "Revenue across popular blockchains.",

  "leaderboards-net_revenue_24h":
    "Revenue minus token incentives in the past 24 hours. If this number is negative, the project spends more on token issuance than earns in revenues.",
  "leaderboards-net_revenue_1d":
    "Revenue minus token incentives in the past 24 hours. If this number is negative, the project spends more on token issuance than earns in revenues.",
  "leaderboards-net_revenue_7d":
    "Revenue minus token incentives in the past 7 days. If this number is negative, the project spends more on token issuance than earns in revenues.",
  "leaderboards-net_revenue_30d":
    "Revenue minus token incentives in the past 30 days. If this number is negative, the project spends more on token issuance than earns in revenues.",
  "leaderboards-net_revenue_90d":
    "Revenue minus token incentives in the past 90 days. If this number is negative, the project spends more on token issuance than earns in revenues.",
  "leaderboards-net_revenue_180d":
    "Revenue minus token incentives in the past 180 days. If this number is negative, the project spends more on token issuance than earns in revenues.",
  "leaderboards-net_revenue_365d":
    "Revenue minus token incentives in the past 365 days. If this number is negative, the project spends more on token issuance than earns in revenues.",
  "leaderboards-net_revenue_all":
    "Revenue minus token incentives since launch. If this number is negative, the project spends more on token issuance than earns in revenues.",

  "leaderboards-revenue_1d":
    "Daily fees. Total fees paid in the past 24 hours.",
  "leaderboards-revenue_24h":
    "Daily fees. Total fees paid in the past 24 hours.",
  "leaderboards-revenue_7d": "Weekly fees. Total fees paid in the past 7 days.",
  "leaderboards-revenue_30d":
    "Monthly fees. Total fees paid in the past 30 days.",
  "leaderboards-revenue_90d":
    "Quarterly fees. Total fees paid in the past 90 days.",
  "leaderboards-revenue_180d":
    "Semi-annual fees. Total fees paid in the past 180 days.",
  "leaderboards-revenue_365d":
    "Annual fees. Total fees paid in the past 365 days.",
  "leaderboards-revenue_all": "Total fees paid since launch.",
  "projects-table-title": "Data about projects listed on Token Terminal.",
  "markets-table-title": "Data about listed projects in current category.",
  "metrics-table-title": "Data about listed projects.",
  "total-revenue-dapps": "Fees across popular decentralized applications.",
  "total-revenue-blockchains": "Fees across popular blockchains.",
  "protocol-revenue-dapps":
    "Revenue across popular decentralized applications.",
  "protocol-revenue-blockchains": "Revenue across popular blockchains.",
  "metrics-total-tvl-defi":
    "Total value locked in listed decentralized applications.",
  "metrics-tvl-dominance":
    "The leading decentralized application's share of total TVL.",
  "metrics-tvl-highest":
    "Highest total value locked out of listed decentralized applications.",
  "metrics-tvl-lowest":
    "Lowest total value locked out of listed decentralized applications.",
  "metrics-highest-pf-defi":
    "Highest P/F ratio out of listed decentralized applications.",
  "metrics-lowest-pf-defi":
    "Lowest P/F ratio out of listed decentralized applications.",
  "metrics-highest-ps-blockchain":
    "Highest P/F ratio out of listed blockchains.",
  "metrics-lowest-ps-blockchain": "Lowest P/F ratio out of listed blockchains.",
  "metrics-protocol-revenue-defi":
    "Fees generated for the tokenholders in listed decentralized applications.",
  "metrics-protocol-revenue-blockchain":
    "Fees generated for the tokenholders in listed blockchains.",
  "metrics-protocol-revenue-dominance-defi":
    "The leading decentralized application's share of fees.",
  "metrics-protocol-revenue-dominance-blockchain":
    "The leading blockchain's share of fees.",
  "metrics-total-revenue-defi":
    "Fees generated in listed decentralized applications.",
  "metrics-total-revenue-blockchain":
    "Fees generated for the tokenholders in listed blockchains.",
  "metrics-revenue-dominance-defi":
    "The leading decentralized application's share of fees.",
  "metrics-revenue-dominance-blockchain":
    "The leading blockchain's share of fees.",
  "metrics-highest-pe-defi":
    "Highest P/S ratio out of listed decentralized applications.",
  "metrics-lowest-pe-defi":
    "Lowest P/S ratio out of listed decentralized applications.",
  "metrics-highest-pe-blockchain":
    "Highest P/S ratio out of listed blockchains.",
  "metrics-lowest-pe-blockchain": "Lowest P/S ratio out of listed blockchains.",
  "chart-pe":
    "Calculated by dividing the fully diluted market cap with the annualized revenue. Shows how a project is valued in relation to its revenue.",
  "pe-dapps": "P/S ratio across popular decentralized applications.",
  "pe-blockchains": "P/S ratio across popular blockchains.",
  "data-not-available": {
    default: "Data not available yet. We are working on adding this data.",
    "not-available": "Data not available.",
    "not-launched":
      "This project has not launched its token (yet). This data will be added immediately after the launch event.",
    "not-diluted":
      "Fully diluted market cap is not available as maximum amount of tokens issued has not been defined in the smart contract.",
    "custom-metric-not-found":
      "Requested metric was not found, please try adding metric again.",
  },
  exchange: {
    "markets-title": "Explore decentralized exchange protocols.",
    "markets-total-revenue":
      "Total trading fees generated by listed exchanges.",
    "markets-total-ps": "Median P/F ratio of listed exchanges.",
    "markets-median-revenue":
      "Median of total trading fees generated by listed exchanges.",
    "markets-dominance": "The leading exchange’s share of total trading fees.",
  },
  lending: {
    "markets-title": "Explore decentralized lending protocols.",
    "markets-total-revenue":
      "Total borrow interest generated on listed lending protocols.",
    "markets-total-ps": "Median P/F ratio of listed lending protocols.",
    "markets-median-revenue":
      "Median of total borrow interest generated by listed lending protocols.",
    "markets-dominance":
      "The leading lending protocol’s share of total borrow interest.",
  },
  blockchain: {
    "markets-title": "Explore blockchains.",
    "markets-total-revenue":
      "Total transaction fees generated on listed blockchains.",
    "markets-total-ps": "Median P/F ratio of listed blockchains.",
    "markets-median-revenue":
      "Median of total transaction fees generated by listed blockchains.",
    "markets-dominance":
      "The leading blockchains’s share of total transaction fees.",
  },
  defi: {
    "markets-title": "Explore decentralized finance protocols.",
    "markets-total-revenue": "Fees generated on listed DeFi protocols.",
    "markets-total-ps": "Median P/F ratio of listed DeFi protocols.",
    "markets-median-revenue":
      "Median of fees generated by listed DeFi protocols.",
    "markets-dominance":
      "The leading DeFi protocol’s share of total transaction fees.",
  },
  uniswap: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Uniswap on an annualized basis. Calculated based on past 30D average.",
  },
  mcdex: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on MCDEX on an annualized basis. Calculated based on past 30D average.",
  },
  gmx: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on GMX on an annualized basis. Calculated based on past 30D average.",
  },
  cap: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Cap on an annualized basis. Calculated based on past 30D average.",
  },
  "saddle-finance": {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Saddle on an annualized basis. Calculated based on past 30D average.",
  },
  "yield-guild-games": {
    "project-revenue-7d": "Total SLP revenue in the past 7 days.",
    "project-revenue-30d": "Total SLP revenue in the past 30 days.",
    "project-revenue-annualized":
      "Total SLP revenue on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol": "-",
  },
  "integral-protocol": {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Integral on an annualized basis. Calculated based on past 30D average.",
  },
  "swerve-finance": {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Swerve on an annualized basis. Calculated based on past 30D average.",
  },
  pangolin: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Pangolin on an annualized basis. Calculated based on past 30D average.",
  },
  piedao: {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on PieDAO on an annualized basis. Calculated based on past 30D average.",
  },
  powerpool: {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on Powerpool on an annualized basis. Calculated based on past 30D average.",
  },
  aave: {
    "project-revenue-7d":
      "Total interest & trading fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total interest & trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest & trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on Aave on an annualized basis. Calculated based on past 30D average.",
  },
  "0x": {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on 0x on an annualized basis. Calculated based on past 30D average.",
  },
  "88mph": {
    "project-revenue-7d": "Total interest paid in the past 7 days.",
    "project-revenue-30d": "Total interest paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on 88mph on an annualized basis. Calculated based on past 30D average.",
  },
  balancer: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Balancer on an annualized basis. Calculated based on past 30D average.",
  },
  bancor: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Balancer on an annualized basis. Calculated based on past 30D average.",
  },
  curve: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Curve on an annualized basis. Calculated based on past 30D average.",
  },
  "ellipsis-finance": {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Ellipsis on an annualized basis. Calculated based on past 30D average.",
  },
  dodo: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on DODO on an annualized basis. Calculated based on past 30D average.",
  },
  dydx: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on dYdX on an annualized basis. Calculated based on past 30D average.",
  },
  futureswap: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Futureswap on an annualized basis. Calculated based on past 30D average.",
  },
  idex: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on IDEX on an annualized basis. Calculated based on past 30D average.",
  },
  kyber: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Kyber on an annualized basis. Calculated based on past 30D average.",
  },
  loopring: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Loopring on an annualized basis. Calculated based on past 30D average.",
  },
  "indexed-finance": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on Indexed Finance on an annualized basis. Calculated based on past 30D average.",
  },
  mstable: {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total  return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on mStable on an annualized basis. Calculated based on past 30D average.",
  },
  "perpetual-protocol": {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Perpetual Protocol on an annualized basis. Calculated based on past 30D average.",
  },
  polymarket: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Polymarket on an annualized basis. Calculated based on past 30D average.",
  },
  sushiswap: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Sushiswap on an annualized basis. Calculated based on past 30D average.",
  },
  hurricaneswap: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Hurricaneswap on an annualized basis. Calculated based on past 30D average.",
  },
  synthetix: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Synthetix on an annualized basis. Calculated based on past 30D average.",
  },
  tokenlon: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Tokenlon on an annualized basis. Calculated based on past 30D average.",
  },
  "binance-chain": {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Transaction volume on Binance Chain on an annualized basis. Calculated based on past 30D average.",
  },
  bitcoin: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume Bitcoin on an annualized basis. Calculated based on past 30D average.",
  },
  ethereum: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Ethereum on an annualized basis. Calculated based on past 30D average.",
  },
  "pocket-network": {
    "project-revenue-7d": "",
    "project-revenue-30d": "",
    "project-revenue-annualized": "",
    "project-annualized-transaction-vol":
      "Total transaction volume on Pocket Network on an annualized basis. Calculated based on past 30D average.",
  },
  decred: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Decred on an annualized basis. Calculated based on past 30D average.",
  },
  dogecoin: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Dogecoin on an annualized basis. Calculated based on past 30D average.",
  },
  filecoin: {
    "project-revenue-7d":
      "Total transaction & storage fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total transaction & storage fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction & storage fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Filecoin on an annualized basis. Calculated based on past 30D average.",
  },
  kusama: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Kusama on an annualized basis. Calculated based on past 30D average.",
  },
  polkadot: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Polkadot on an annualized basis. Calculated based on past 30D average.",
  },
  litecoin: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Litecoin on an annualized basis. Calculated based on past 30D average.",
  },
  rarible: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Rarible on an annualized basis. Calculated based on past 30D average.",
  },
  stellar: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Stellar on an annualized basis. Calculated based on past 30D average.",
  },
  terra: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Terra on an annualized basis. Calculated based on past 30D average.",
  },
  tezos: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Tezos on an annualized basis. Calculated based on past 30D average.",
  },
  zcash: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on zCash on an annualized basis. Calculated based on past 30D average.",
  },
  thorchain: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Thorchain on an annualized basis. Calculated based on past 30D average.",
  },
  xdai: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on xDAI on an annualized basis. Calculated based on past 30D average.",
  },
  fantom: {
    "project-revenue-7d": "Total transaction fees paid in the past 7 days.",
    "project-revenue-30d": "Total transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Fantom on an annualized basis. Calculated based on past 30D average.",
  },
  arweave: {
    "project-revenue-7d":
      "Total storage and transaction fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total storage and transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total storage and transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Arweave on an annualized basis. Calculated based on past 30D average.",
  },
  karura: {
    "project-revenue-7d":
      "Total storage and transaction fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total storage and transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total storage and transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Karura on an annualized basis. Calculated based on past 30D average.",
  },
  helium: {
    "project-revenue-7d":
      "Total data transfer and transaction fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total data transfer and transaction fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total data transfer and transaction fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total data transfer transaction volume on Helium on an annualized basis. Calculated based on past 30D average.",
  },
  compound: {
    "project-revenue-7d": "Total interest paid in the past 7 days.",
    "project-revenue-30d": "Total interest paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on Compound on an annualized basis. Calculated based on past 30D average.",
  },
  centrifuge: {
    "project-revenue-7d": "Total interest paid in the past 7 days.",
    "project-revenue-30d": "Total interest paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on Tinlake on an annualized basis. Calculated based on past 30D average.",
  },
  cream: {
    "project-revenue-7d": "Total interest paid in the past 7 days.",
    "project-revenue-30d": "Total interest paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on Cream on an annualized basis. Calculated based on past 30D average.",
  },
  makerdao: {
    "project-revenue-7d":
      "Total interest, trading & liquidation fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total interest, trading & liquidation fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest, trading & liquidation fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on MakerDAO on an annualized basis. Calculated based on past 30D average.",
  },
  reflexer: {
    "project-revenue-7d": "Total interest paid in the past 7 days.",
    "project-revenue-30d": "Total interest paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on Reflexer on an annualized basis. Calculated based on past 30D average.",
  },
  "unit-protocol": {
    "project-revenue-7d": "Total interest paid in the past 7 days.",
    "project-revenue-30d": "Total interest paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on Unit on an annualized basis. Calculated based on past 30D average.",
  },
  venus: {
    "project-revenue-7d": "Total interest paid in the past 7 days.",
    "project-revenue-30d": "Total interest paid in the past 30 days.",
    "project-revenue-annualized":
      "Total interest paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on Venus on an annualized basis. Calculated based on past 30D average.",
  },
  "yearn-finance": {
    "project-revenue-7d": "Total return on investment in the past 7 days.",
    "project-revenue-30d": "Total return on investment in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investmentn on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on yearn on an annualized basis. Calculated based on past 30D average.",
  },
  "vesper-finance": {
    "project-revenue-7d": "Total return on investment in the past 7 days.",
    "project-revenue-30d": "Total return on investment in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investmentn on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on yearn on an annualized basis. Calculated based on past 30D average.",
  },
  hegic: {
    "project-revenue-7d":
      "Total premium & settlement fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total premium & settlement fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total premium & settlement fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total notional transaction volume on Hegic on an annualized basis. Calculated based on past 30D average.",
  },
  lyra: {
    "project-revenue-7d": "Total premiums paid in the past 7 days.",
    "project-revenue-30d": "Total premiums paid in the past 30 days.",
    "project-revenue-annualized":
      "Total premiums paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total notional transaction volume on Lyra on an annualized basis. Calculated based on past 30D average.",
  },
  keeperdao: {
    "project-revenue-7d": "Total return on investment in the past 7 days.",
    "project-revenue-30d": "Total return on investment in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total flash loan volume on an annualized basis. Calculated based on past 30D average.",
  },
  livepeer: {
    "project-revenue-7d": "Total transcoding fees paid in the past 7 days.",
    "project-revenue-30d": "Total transcoding fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total transcoding fees paid on an annualized basis. Calculated based on past 30D average.",
  },
  metamask: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Metamask on an annualized basis. Calculated based on past 30D average.",
  },
  "mirror-protocol": {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Mirror Protocol on an annualized basis. Calculated based on past 30D average.",
  },
  "nexus-mutual": {
    "project-revenue-7d": "Total insurance fees paid in the past 7 days.",
    "project-revenue-30d": "Total insurance fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total insurance fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total cover purchased on an annualized basis. Calculated based on past 30D average.",
  },
  pancakeswap: {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on PancakeSwap on an annualized basis. Calculated based on past 30D average.",
  },
  pooltogether: {
    "project-revenue-7d": "Total return on investment in the past 7 days.",
    "project-revenue-30d": "Total return on investment in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on Pooltogether volume on an annualized basis. Calculated based on past 30D average.",
  },
  ren: {
    "project-revenue-7d": "Total burn & mint fees paid in the past 7 days.",
    "project-revenue-30d": "Total burn & mint fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total burn & mint fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Ren on an annualized basis. Calculated based on past 30D average.",
  },
  "keep-network": {
    "project-revenue-7d": "Total deposit fees paid in the past 7 days.",
    "project-revenue-30d": "Total deposit fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total deposit fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Keep Network on an annualized basis. Calculated based on past 30D average.",
  },
  uma: {
    "project-annualized-transaction-vol":
      "Transaction volume on an annualized basis. Calculated based on past 30D average.",
  },
  "alchemix-finance": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on an annualized basis. Calculated based on past 30D average.",
  },
  autofarm: {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "enzyme-finance": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "fei-protocol": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "harvest-finance": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  barnbridge: {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "idle-finance": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "lido-finance": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "visor-finance": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "index-cooperative": {
    "project-revenue-7d": "Total streaming fees paid in the past 7 days.",
    "project-revenue-30d": "Total streaming fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total streaming fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
    "composition-revenue": "Total streaming fees paid",
  },
  "basket-dao": {
    "project-revenue-7d": "Total yield earned paid in the past 7 days.",
    "project-revenue-30d": "Total yield earned paid in the past 30 days.",
    "project-revenue-annualized":
      "Total yield earned  paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  instadapp: {
    "project-revenue-7d": "Total strategy fees paid in the past 7 days.",
    "project-revenue-30d": "Total strategy fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total strategy fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume on Instadapp on an annualized basis. Calculated based on past 30D average.",
  },
  liquity: {
    "project-revenue-7d":
      "Total withdrawal & redemption fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total withdrawal & redemption fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total withdrawal & redemption fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total borrow volume on an annualized basis. Calculated based on past 30D average.",
  },
  "notional-finance": {
    "project-revenue-7d": "Total trading fees paid in the past 7 days.",
    "project-revenue-30d": "Total trading fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total trading fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on Pangolin on an annualized basis. Calculated based on past 30D average.",
  },
  "rari-capital": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "siren-markets": {
    "project-revenue-7d": "Total premiums paid in the past 7 days.",
    "project-revenue-30d": "Total premiums paid in the past 30 days.",
    "project-revenue-annualized":
      "Total premiums paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total trading volume on SIREN on an annualized basis. Calculated based on past 30D average.",
    "keymetrics-revenue": "The premiums paid on the exchange",
  },
  "stake-dao": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "set-protocol": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "ribbon-finance": {
    "project-revenue-7d": "Total return on investment paid in the past 7 days.",
    "project-revenue-30d":
      "Total return on investment paid in the past 30 days.",
    "project-revenue-annualized":
      "Total return on investment paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total capital deployed on an annualized basis. Calculated based on past 30D average.",
  },
  "axie-infinity": {
    "project-revenue-7d":
      "Total ingame purchases and marketplace fees paid in the past 7 days.",
    "project-revenue-30d":
      "Total ingame purchases and marketplace fees paid in the past 30 days.",
    "project-revenue-annualized":
      "Total ingame purchases and marketplace fees paid on an annualized basis. Calculated based on past 30D average.",
    "project-annualized-transaction-vol":
      "Total transaction volume in the marketplace on an annualized basis. Calculated based on past 30D average.",
  },
}
